module.exports = __webpack_public_path__ + "img/investment_9.c2729f77.jpg";